import script from "./MamoAppProvider.vue?vue&type=script&lang=ts"
export * from "./MamoAppProvider.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__